import { useState } from 'react';
import styled, { keyframes } from 'styled-components';

interface StyleType {
  isOpen?: Boolean;
}

const Txts = styled.span`
  display: inline-block;
  vertical-align: top;
  font-family: 'SDGothicNeobTTF-bLt';
  color: #333;
  font-size: 16px;
  font-size: 1rem;
  margin-right: 23px;
  margin-right: 1.4375rem;
  &.font-family-sb {
    font-weight: bold;
  }
`;
const FooterUtilArea = styled.div`
  display: table-cell;
  vertical-align: top;
  text-align: right;
`;
const FamilySiteWrap = styled.div`
  display: inline-block;
  width: 210px;
  width: 13.125rem;
  height: 48px;
  height: 3rem;
  position: relative;
`;
const HideTxt = styled.span`
  display: ${(props: StyleType) => (props.isOpen ? 'inline-block' : 'none')};
  overflow: hidden;
  position: absolute;
  width: 1px;
  height: 1px;
  font-size: 1px;
  line-height: 0;
  clip: rect(0 0 0 0);
  white-space: nowrap;
  margin: -1px;
  padding: 0;
  border: 0;
`;
const BtnFamilySite = styled.button`
  cursor: pointer;
  position: relative;
  z-index: 1;
  display: inline-block;
  width: 210px;
  width: 13.125rem;
  height: 48px;
  height: 3rem;
  padding: 0 20px 0 20px;
  padding: 0 1.25rem 0 1.25rem;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  background-color: #eaeaea;
  text-align: left;
  border: none;

  :focus {
    outline: none;
  }
`;

const Ico = styled.span`
  position: absolute;
  top: 50%;
  right: 1.25rem;
  width: 0.8125rem;
  height: 0.8125rem;
  margin-top: -0.375rem;
`;
const Line01 = styled.span`
  position: absolute;
  width: 1px;
  height: 13px;
  top: 0;
  left: 50%;
  margin-left: -1px;
  background-color: #999;
  -webkit-transition: all ease 0.3s;
  -o-transition: all ease 0.3s;
  transition: all ease 0.3s;
  -webkit-transform: ${(props: StyleType) => (props.isOpen ? 'rotate(45deg)' : 'none')};
  -ms-transform: ${(props: StyleType) => (props.isOpen ? ' rotate(45deg)' : 'none')};
  transform: ${(props: StyleType) => (props.isOpen ? ' rotate(45deg)' : 'none')};
`;
const Line02 = styled.span`
  position: absolute;
  width: 13px;
  height: 1px;
  top: 50%;
  left: 0;
  margin-top: -1px;
  background-color: #999;
  -webkit-transition: all ease 0.3s;
  -o-transition: all ease 0.3s;
  transition: all ease 0.3s;
  -webkit-transform: ${(props: StyleType) => (props.isOpen ? 'rotate(45deg)' : 'none')};
  -ms-transform: ${(props: StyleType) => (props.isOpen ? ' rotate(45deg)' : 'none')};
  transform: ${(props: StyleType) => (props.isOpen ? ' rotate(45deg)' : 'none')};
`;
const FamilySiteList = styled.ul`
  border: 1px solid #eaeaea;
  border-bottom: 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 10px 0 10px 0;
`;

const UpBox = keyframes`
  0%{opacity:0;bottom:80%}
  100%{opacity:1;bottom:100%}
`;

const FamilySiteListWrap = styled.div`
  display: ${(props: StyleType) => (props.isOpen ? 'block' : 'none')};
  /* animation:${(props: StyleType) => (props.isOpen ? 'up-box 0.3s ease-out both' : 'none')}; */
  animation: ${UpBox} 0.3s ease-out both;

  -webkit-animation: ${UpBox} 0.3s ease-out both;
  left: 0;
  bottom: 100%;
  position: absolute;
  width: 100%;
  background: #fff;
`;
const Link = styled.a`
  display: block;
  text-align: left;
  padding: 10px 30px 10px 30px;
  padding: 0.625rem 1.875rem 0.625rem 1.875rem;
  background: #fff;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  background-color: #ffffff;
  ::before {
    content: ' ';
    position: absolute;
    font-size: 0;
  }
`;
const Txt = styled.span`
  font-family: 'SDGothicNeobTTF-bLt';
  color: #666;
  font-size: 14px;
  font-size: 0.875rem;
  :hover {
    color: #ff671d;
    transition: color 0.3s ease, border 0.3s ease, background-color 0.3s;
  }
`;
const SiteMap = () => {
  const [click, setClick] = useState(false);

  const clickHandler = () => {
    setClick(() => !click);
  };

  const footerWrapper: any = () => {
    return (
      <FamilySiteWrap>
        <BtnFamilySite type="button" onClick={clickHandler}>
          <Txts>Family Site</Txts>
          <HideTxt isOpen={!click}>닫힘</HideTxt>
          <HideTxt isOpen={click}>열림</HideTxt>
          <Ico aria-hidden="true">
            <Line01 aria-hidden="true" isOpen={click}></Line01>
            <Line02 aria-hidden="true" isOpen={click}></Line02>
          </Ico>
        </BtnFamilySite>
        <FamilySiteListWrap isOpen={click}>
          <FamilySiteList>
            <li>
              <Link href="https://www.elife.co.kr/" target="_blank" title="새창열기">
                <Txt>DL이앤씨 e편한세상</Txt>
              </Link>
            </li>
            <li>
              <Link href="https://www.dlconstruction.co.kr/" target="_blank" title="새창열기">
                <Txt>DL건설</Txt>
              </Link>
            </li>
          </FamilySiteList>
        </FamilySiteListWrap>
      </FamilySiteWrap>
    );
  };

  return <FooterUtilArea>{footerWrapper()}</FooterUtilArea>;
};

export default SiteMap;
